import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SaveSearch from 'ui/modules/saveSearch'

import { getSearchToSave } from 'services/searches/selectors'
import { saveSearch } from 'services/searches/actions'

const SaveNewSearchModal = props => {
  const { isOpen, onClose } = props

  const dispatch = useDispatch()
  const searchToSave = useSelector(getSearchToSave)

  const handleSubmit = name => {
    dispatch(saveSearch({ ...searchToSave, name }))
    onClose()
  }

  return (
    <SaveSearch
      isOpen={Boolean(isOpen)}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default SaveNewSearchModal
